import { useShowMessage } from "../../functions/Common/showMessage";
import useFetch from "../../hooks/useFetch";

export default function useSendFile() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  function sendFile(folderPath, fileName) {
    fetchWrapper({
      endpoint_url: "file_operation/sendFile",
      set_content_type_header: false,
      method: "GET",
      params: {
        folder_path: folderPath,
        file_name: fileName,
      },
      json_output: false,
      onSuccess: (response) => {
        response.blob().then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.setAttribute("download", fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });
      },
      onFetchError: () => {
        showMessage({ apiType: "fetch", message: "send file" });
      },
      onResponseError: () => {
        showMessage({ apiType: "response", message: "send file" });
      },
    });
  }
  return { sendFile };
}
